import AbstractDataAttributeBehaviour from "./abstract-data-attribute-behaviour";
export default class PlaceHolderSetterBehaviour extends AbstractDataAttributeBehaviour {
    attrNames = {
        'container': 'data-form-changer'
    };

    getContainerSelector() {
        return '[' + this.attrNames.container + ']';
    }

    initContainer(container) {
        this.toggleDisplay(container.value);
        container.addEventListener("change", this.updateFields);
    }

    updateFields = e => {
        const selectedValue = e.target.value;
        this.toggleDisplay(selectedValue);
    }

    toggleDisplay = value => {
        if (value.indexOf('Make a new booking') === -1) {
            document.getElementById('callback-passengers').style.display = 'none';
        } else {
            document.getElementById('callback-passengers').style.display = 'block';
        }
    }
}